import { render, staticRenderFns } from "./MyManuscript.vue?vue&type=template&id=c703fe8c&scoped=true&"
import script from "./MyManuscript.vue?vue&type=script&lang=js&"
export * from "./MyManuscript.vue?vue&type=script&lang=js&"
import style0 from "./MyManuscript.vue?vue&type=style&index=0&id=c703fe8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c703fe8c",
  null
  
)

export default component.exports